import React from 'react';
import { Button } from '@/components/ui/button';

export interface BulkActionsSectionProps {
  onSelectAll: () => void;
  onClearAll: () => void;
}

export const BulkActionsSection: React.FC<BulkActionsSectionProps> = ({
  onSelectAll,
  onClearAll,
}) => {
  return (
    <div className="flex justify-between items-center">
      <Button
        variant="ghost"
        size="sm"
        onClick={onSelectAll}
        className="hover:bg-transparent hover:underline p-0 h-auto"
      >
        Select All
      </Button>
      <Button
        variant="ghost"
        size="sm"
        onClick={onClearAll}
        className="hover:bg-transparent hover:underline text-muted-foreground p-0 h-auto"
      >
        Clear All
      </Button>
    </div>
  );
};
